import type { VersionInfo } from '../types/firmware'

/**
 * @file firmwareVersion.ts
 * @description 固件版本展示格式化工具，用于把多段固件版本转换成配置快照里稳定的字符串。
 */

export function formatFirmwareVersions(versions: VersionInfo[]): string {
  return versions.map((item) => `${item.versionType}:${item.version}`).join(';')
}
